export default {
  methods: {
    nl2br(val) {
      return val.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/mixins.js